import DefaultTheme from "@/themes/default.theme";
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "LivelyHeadlineBold";
    src: local("LivelyHeadlineBold"), asset-url("/fonts/LivelyHeadline-Bold.ttf") format("truetype");
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    preload: true;
  }
  ${(()=>{
    let fontFace = {};
    DefaultTheme?.fontFaces?.forEach((face: any)=>{
      fontFace = {...fontFace, ...face}
    })
    return fontFace;
  })()}

  body {
    font-family: "NotoIKEALatinRegular", sans-serif;
    transition: all 0.50s linear;
  }
`
    // background: ${(theme) => theme.body};
    // color: ${(theme) => theme.text};
    // font-family: Tahoma, Helvetica, Arial, Roboto, sans-serif;

export default GlobalStyles;